import { render, staticRenderFns } from "./ListaUsuariosInscritos.vue?vue&type=template&id=258b94f8"
import script from "./ListaUsuariosInscritos.vue?vue&type=script&lang=js"
export * from "./ListaUsuariosInscritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports